import { PageLayout } from '@components/PageLayout/PageLayout';
import { NextPage } from 'next';
import s from './artistsPage.module.scss';
import cn from 'classnames';
import { ExpectedProps, ServerPropsFactory } from '@lib/factory/serverprops';
import { useTranslation } from '@hooks/useTranslation';
import { ArtistsList } from '@components/Pages/ArtistsPage/ArtistsList/ArtistsList';
import { Search } from '@components/UIKit/Search/Search';
import { Breadcrumb } from '@components/UIKit/Breadcrumb/Breadcrumb';
export const getServerSideProps = ServerPropsFactory(async (props: ExpectedProps) => ({
  ...props
}));
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = () => {
  const {
    translate: tr
  } = useTranslation();
  return <PageLayout showBackIconOnMobile data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.gamesPage}>
                <div className={cn(s.gamesPage__container, '_container')}>
                    <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="index.tsx" />
                    <div className={s.gamesPage__top}>
                        <div className={cn(s.gamesPage__title, '_title')}>
                            {tr({
              id: 'artists.page.title'
            })}
                        </div>

                        <Search boxClassName={s.gamesPage__search} placeholder={tr({
            id: 'enter.artist.name'
          })} name={'toys'} data-sentry-element="Search" data-sentry-source-file="index.tsx" />
                    </div>
                    <div className={s.gamesPage__main}>
                        <ArtistsList data-sentry-element="ArtistsList" data-sentry-source-file="index.tsx" />
                    </div>
                </div>
            </div>
        </PageLayout>;
};
export default Page;